<template>
    <div>
        <b-card class="mb-3" header-tag="header">
            <div slot="header">
                Audit Trail
            </div>
            
            <b-table bordered striped hover show-empty 
                :items="audit_trail" 
                :fields="fields" />
        </b-card>
    </div>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';

    export default {
        props: ['audit_trail'],

        mixins: [FormatsDates],

        data() {
            return {
                fields: [
                    {key: 'timestamp', label: 'Date', formatter: x => this.formatDateTimeFromUTC(x)},
                    {key: 'modified_fields', label: 'Fields'},
                    {key: 'event', label: 'Event'},
                ],
            };
        },
    }
</script>